<page-toolbar [pageActions]="pageActions" [subtitle]="subtitle" [title]="'translation.' + (translationId ? 'edit' : 'create') | translate"></page-toolbar>

<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<page-content>
  <mat-card appearance="outlined">
    <mat-card-title>Details</mat-card-title>
    <div class="form-container">
      <ng-template formHost></ng-template>
    </div>
  </mat-card>
</page-content>
